import React, {useEffect, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {BASE_URL} from '../config';

function DuplicateProductModal({show, product, onHide, onCreate}) {
    const [duplicateData, setDuplicateData] = useState(product ? {...product} : {});
    const [locations, setLocations] = useState([]);
    const [warehouses, setWarehouses] = useState([]);

    useEffect(() => {
        if (product) {
            setDuplicateData({...product});
            fetchLocations();
            fetchWarehouses();
        } else {
            setDuplicateData({});
        }
    }, [product]);

    
    const fetchLocations = () => {
        fetch(`${BASE_URL}/api/locations`)
            .then(response => response.json())
            .then(data => setLocations(data))
            .catch(error => console.error('Error fetching locations:', error));
    };

    const fetchWarehouses = () => {
        fetch(`${BASE_URL}/api/warehouses`)
            .then(response => response.json())
            .then(data => setWarehouses(data))
            .catch(error => console.error('Error fetching warehouses:', error));
    };

    const handleChange = (key, value) => {
        setDuplicateData(prev => ({...prev, [key]: value}));
    };

    const handleCreate = () => {
        // Create FormData object instead of regular object
        const formData = new FormData();
        
        Object.entries(duplicateData).forEach(([key, value]) => {
            if (key === 'image') {
                formData.append('image_filename', value);
            } else if (key === 'lokalizacja') {
                const location = locations.find(loc => loc.name === value);
                if (location) {
                    formData.append('location_id', location.location_id);
                }
            } else if (key === 'magazyn') {
                const warehouse = warehouses.find(wh => wh.name === value);
                if (warehouse) {
                    formData.append('magazyn_id', warehouse.id);
                }
            } else if (!['id', 'date', 'is_sold', 'location_id', 'magazyn_id'].includes(key)) {
                formData.append(key, value);
            }
        });
        
        onCreate(formData);
    };

    if (!product) return null;

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Zduplikuj produkt</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form id="duplicateForm" onSubmit={(e) => {
                    e.preventDefault();
                    handleCreate();
                }}>
                    {Object.keys(duplicateData).map(key => {
                        

                        if (key === 'lokalizacja') {
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`duplicate-${key}`} className="form-label">Lokalizacja</label>
                                    <select
                                        className="form-select"
                                        id={`duplicate-${key}`}
                                        value={duplicateData[key]}
                                        onChange={e => handleChange(key, e.target.value)}   
                                    >
                                        <option value="">Wybierz lokalizację</option>
                                        {locations.map(location => (
                                            <option key={location.name} value={location.name}>
                                                {location.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            );
                        }

                        if (key === 'magazyn') {
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`duplicate-${key}`} className="form-label">Magazyn</label>
                                    <select
                                        className="form-select"
                                        id={`duplicate-${key}`}
                                        value={duplicateData[key]}
                                        onChange={e => handleChange(key, e.target.value)}
                                    >
                                        <option value="">Wybierz magazyn</option>
                                        {warehouses.map(warehouse => (
                                            <option key={warehouse.name} value={warehouse.name}>
                                                {warehouse.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            );
                        }
                        if (key === 'name'){
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`duplicate-${key}`} className="form-label">Nazwa</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id={`duplicate-${key}`}
                                        value={duplicateData[key] || ''}
                                        onChange={e => handleChange(key, e.target.value)}
                                    />
                                </div>
                            );
                        }   
                        if (key === 'size'){
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`duplicate-${key}`} className="form-label">Rozmiar</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id={`duplicate-${key}`}
                                        value={duplicateData[key] || ''}
                                        onChange={e => handleChange(key, e.target.value)}
                                    />
                                </div>
                            );
                        }
                        if (key === 'category'){
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`duplicate-${key}`} className="form-label">Kategoria</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id={`duplicate-${key}`}
                                        value={duplicateData[key] || ''}
                                        onChange={e => handleChange(key, e.target.value)}
                                    />
                                </div>
                            );
                        }
                        if (key === 'sale_price'){
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`duplicate-${key}`} className="form-label">Cena sprzedaży</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id={`duplicate-${key}`}
                                        value={duplicateData[key] || ''}
                                        onChange={e => handleChange(key, e.target.value)}
                                    />
                                </div>
                            );
                        }
                        if (key ==='buy_price'){
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`duplicate-${key}`} className="form-label">Cena zakupu</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id={`duplicate-${key}`}
                                        value={duplicateData[key] || ''}
                                        onChange={e => handleChange(key, e.target.value)}
                                    />
                                </div>
                            );
                        }
                        if (key === 'consignment_price'){
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`duplicate-${key}`} className="form-label">Cena w komisie</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control"
                                        id={`duplicate-${key}`}
                                        value={duplicateData[key] ?? ''}
                                        onChange={e => handleChange(key, e.target.value)}
                                    />
                                </div>
                            );
                        }
                        if (key === 'note'){
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`duplicate-${key}`} className="form-label">Notatka</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id={`duplicate-${key}`}
                                        value={duplicateData[key] || ''}
                                        onChange={e => handleChange(key, e.target.value)}
                                    />
                                </div>
                            );
                        }
                        if (key === 'shop' || key === 'order') {
                            return null;
                        }
                        if (key === 'ksfv') {
                            return (
                                <div key={key} className="mb-3">
                                    <label htmlFor={`duplicate-${key}`} className="form-label">UKS/FV</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id={`duplicate-${key}`}
                                        value={duplicateData[key] || ''}
                                        onChange={e => handleChange(key, e.target.value)}
                                    />
                                </div>
                            );
                        }
                        if (key === 'is_sold'|| key === 'date' || key === 'image_filename' || key === 'id' || key === 'image' || key === 'location_id' || key === 'magazyn_id'){
                            return null;
                        }
                        
                        return (
                            <div key={key} className="mb-3">
                                <label htmlFor={`duplicate-${key}`} className="form-label">{key}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id={`duplicate-${key}`}
                                    value={duplicateData[key] || ''}
                                    onChange={e => handleChange(key, e.target.value)}
                                    disabled={['sku', 'media', 'image','date','image_filename','is_sold','location_id','magazyn_id'].includes(key)}

                                />
                            </div>
                            
                        );
                        
                    })}
                </form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Zamknij</Button>
                <Button variant="primary" onClick={handleCreate}>Utwórz produkt</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DuplicateProductModal;
